import { createGQLDataContext } from 'utils/createDataContext';
import { FC, useContext, useMemo } from 'react';
import { ShiftModalUIContext } from 'modals/ShiftModal/ShiftModal.ui.context';
import { QUERY_availableTeamMembers } from 'queries';
import { useSSFBehaviors } from 'hooks';
import { pageContextInitialState } from 'types/common.types';
import { ISSFBehaviorsOptions } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { createApolloCache, createApolloClient } from 'providers/ApolloProvider';
import { Order } from 'types/graphql';

export const AvailableMembersDataContext = createGQLDataContext({ ...pageContextInitialState });

const availableTeamMembersClient = createApolloClient({ cache: createApolloCache() });

export const AvailableMembersDataProvider: FC = ({ children }) => {
  const { shift_id } = useContext(ShiftModalUIContext);

  const config = useMemo(() => availableTeamMembersQueryConfig(shift_id), [shift_id]);
  const [values, opts] = useSSFBehaviors(config);
  const value = {
    values,
    ...opts,
    __typename: 'GraphQLAPI',
  };

  return (
    <AvailableMembersDataContext.Provider value={value}>
      {children}
    </AvailableMembersDataContext.Provider>
  );
};

export const availableTeamMembersQueryConfig = (order_id?: string): ISSFBehaviorsOptions => ({
  key: 'AVAILABLE_TEAM_MEMBERS_PAGE',
  paginationType: 'InfiniteScroll',
  client: availableTeamMembersClient,
  query: QUERY_availableTeamMembers,
  pageSize: 10,
  responseTransformer: (rawData) => {
    const node = rawData?.node;
    if (!node) return null as unknown as { order: Order };
    return { order: node as Order };
  },
  schema: {
    id: {
      initialValue: order_id,
    },
  },
});
